// subscriptionService.js
import api from "./api";

export const subscribeToPackage = (data) => {

 return api.post("/subscription/subscribeToPackage", data, {
      requiresAuth: true
  });

};

export const getUserPackageDetails = (id) => {

     return api.get(`/subscription/getUserPackage/${id}`, {
          requiresAuth: true
     });

};